const KNOWN_ROMAN = new Set(['I', 'II', 'III', 'IV']);

/**
 * Localized label for ``Program.certificate_level`` (roman tier only).
 * Unknown tiers fall back to the raw roman string.
 */
export function programCertificateTierLabel(
  roman: string | undefined | null,
  t: (key: string) => string
): string {
  const r = (roman || '').trim();
  if (!r) return '';
  if (KNOWN_ROMAN.has(r)) {
    return t(`programCertificateTier.${r}`);
  }
  return r;
}
